module.exports = __webpack_public_path__ + "static/img/preview-04.02faf0e8.webp";